module.exports = __webpack_public_path__ + "static/media/assisted-hip-lift.dfea4391.png";